const t = {
  name: "IdentityRisk",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22.1,8h-2.6L11,20.7V23h7.7l-0.8,9h2.6L29,19.3V17h-7.7L22.1,8z M13.2,21l6.6-9.9L19.1,19h7.7l-6.6,9.9
			l0.7-7.9H13.2z"/>
		<path class="st0" d="M31,0H0v31c0,5,4,9,9,9h31V9C40,4,36,0,31,0z M2,31V2h29c3.9,0,7,3.1,7,7v29H9C5.1,38,2,34.9,2,31z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as IdentityRisk
};
